import { render, staticRenderFns } from "./labelNodeReportText.vue?vue&type=template&id=509623cc&scoped=true"
import script from "./labelNodeReportText.vue?vue&type=script&lang=js"
export * from "./labelNodeReportText.vue?vue&type=script&lang=js"
import style0 from "./labelNodeReportText.vue?vue&type=style&index=0&id=509623cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509623cc",
  null
  
)

export default component.exports